<template>
  <div
    class="sub-gnb-back-title"
    :class="{
      'animate-gnb': trigger,
      'no-back': !showBack
    }"
  >
    <div class="back-image flex flex-align-center ml-16">
      <nuxt-img
        v-if="showBack"
        src="/icons/outline/chevron-left.svg"
        height="24"
        width="24"
        alt="back"
        @click="routeBack(backUrl, redirectRoot, partnersKey)"
      />
    </div>
    <div
      v-if="title"
      class="title flex flex-align-center ml-16"
    >
      {{ title }}
    </div>
    <div class="right-slot">
      <slot name="right" />
    </div>
  </div>
</template>

<script setup lang="ts">
const { routeBack } = useBack()

const props = withDefaults(
  defineProps<{
    title?: string
    trigger?: boolean
    partnersKey?: string
    redirectRoot?: boolean
    backUrl?: string
    showBack?: boolean
  }>(),
  {
    title: '',
    trigger: false,
    partnersKey: '',
    redirectRoot: false,
    backUrl: '',
    showBack: true
  }
)
</script>

<style scoped lang="scss">
.animate-gnb {
  height: 56px;
  transition: 0.2s all ease-out;
  .title {
    top: -56px;
    left: 46px;
    height: 56px;
    @include headline5;
    transition: 0.3s all ease-out;
  }
}

.animate-gnb.no-back {
  .title {
    left: 0;
  }
}

.right-slot {
  position: absolute;
  right: 16px;
  top: 16px;
  height: 56px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
}
</style>
